import { h } from "snabbdom";
import type { VNode } from "snabbdom";
import type { Card, Msg } from "../types";
import { cardTitle } from "../card-title";
import { showLinkPopover, hideLinkPopover } from "../editor/link-popover";

export function viewBacklinks(
  card: Card,
  cache: Record<string, Card>,
  dispatch: (msg: Msg) => void
): VNode {
  const ids = card.backlinks;
  return h("div.backlinks", [
    h("span.backlinks__title", "Backlinks"),
    ...(ids.length === 0
      ? [h("span.backlinks__empty", "No cards link here yet.")]
      : ids.map((id) => viewBacklinkItem(id, cache[id], dispatch))),
  ]);
}

function viewBacklinkItem(
  id: string,
  card: Card | undefined,
  dispatch: (msg: Msg) => void
): VNode {
  return h(
    "div.backlinks__item.chip.card-link",
    {
      on: {
        click: () => dispatch({ type: "NavigateTo", id }),
        mouseenter: (e: Event) => {
          if (card) showLinkPopover(e.currentTarget as HTMLElement, card.content, 1, dispatch);
        },
        mouseleave: () => hideLinkPopover(),
      },
    },
    [h("span.card-link__label", card ? cardTitle(card.content) : "…")]
  );
}
